//react
import React, { useEffect, useState, useRef, Fragment } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";

// img
import more from "../../../../assets/img/icon/more.svg";

// testData
import { OrderListData } from "../../../../Data";

// 해당페이지는 모바일에서 사라집니다!

export default function MyMain() {
    //페이지 이동
    const navigate = useNavigate();
    const orderPage = () => {
        navigate(`/mypage/myorder`);
    };

    return (
        <Wrap>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>최근 주문</MyPageTitle>
                <MyPageMore
                    onClick={() => {
                        orderPage();
                    }}
                >
                    <MoreText>더보기</MoreText>
                    <MoreIcon src={more} alt="더보기" />
                </MyPageMore>
            </MyPageTitleBox>

            {/* 테이블 */}
            <MyPageTabelWrap>
                {/* 테이블 제목 */}
                <TabelTitle>
                    <TableList>주문일자</TableList>
                    <TableList>주문내역</TableList>
                    <TableList>주문번호</TableList>
                    <TableList>가격</TableList>
                </TabelTitle>

                <TableContentWrap>
                    {/* 테이블 리스트 */}
                    {OrderListData.length > 0 ? (
                        <>
                            {/* 최대 5개까지 보여집니다 */}
                            {OrderListData.map((item, index) => {
                                return (
                                    <OrderListBox key={index}>
                                        <Date>{item.date}</Date>
                                        {item.orderlist.map((list, index) => {
                                            if (index > 0) return;
                                            return (
                                                <React.Fragment key={"productList" + index}>
                                                    <MyPageProduct
                                                        id={list.id}
                                                        productImg={list.productImg}
                                                        itemName={list.itemName}
                                                        price={list.price}
                                                        num={list.num}
                                                        option={list.option}
                                                        i={list.id}
                                                    />
                                                    <OrderNum>{item.ordernum}</OrderNum>
                                                    <OrderPrice>
                                                        <span>{list.price}</span> 원
                                                    </OrderPrice>
                                                </React.Fragment>
                                            );
                                        })}
                                    </OrderListBox>
                                );
                            })}
                        </>
                    ) : (
                        <NotOrderText>주문 내역이 없습니다.</NotOrderText>
                    )}
                </TableContentWrap>

                <Paging>
                    <Pagination />
                </Paging>
            </MyPageTabelWrap>
        </Wrap>
    );
}

const Wrap = styled.section``;

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }
`;
const MyPageMore = styled.div`
    display: flex;
    /* align-items: center; */
    align-items: baseline;
`;
const MoreText = styled.p`
    margin-right: calc(100vw * (10 / 1920));
    font-size: calc(100vw * (15 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-right: calc(100vw * (10 / 1300));
    }
`;
const MoreIcon = styled.img`
    width: calc(100vw * (6 / 1920));
    height: calc(100vw * (11 / 1920));
    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (6 / 1300));
        height: calc(100vw * (11 / 1300));
    }
`;
const MyPageTabelWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }
`;
const TabelTitle = styled.div`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }
`;
const TableList = styled.div`
    text-align: center;

    font-size: calc(100vw * (15 / 1920));

    &:nth-child(1) {
        width: calc(100vw * (124 / 1920));
    }
    &:nth-child(2) {
        width: calc(100vw * (465 / 1920));
    }
    &:nth-child(3) {
        width: calc(100vw * (156 / 1920));
    }
    &:nth-child(4) {
        width: calc(100vw * (95 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        &:nth-child(1) {
            width: calc(100vw * (124 / 1300));
        }
        &:nth-child(2) {
            width: calc(100vw * (465 / 1300));
        }
        &:nth-child(3) {
            width: calc(100vw * (156 / 1300));
        }
        &:nth-child(4) {
            width: calc(100vw * (95 / 1300));
        }
    }
`;
const TableContentWrap = styled.ul``;

const NotOrderText = styled.p`
    margin: calc(100vw * (205 / 1920)) 0;
    font-size: calc(100vw * (15 / 1920));

    text-align: center;
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (205 / 1300)) 0;
        font-size: calc(100vw * (15 / 1300));
    }
`;
const OrderListBox = styled.li`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    & > div {
        flex-shrink: 0;
        font-size: calc(100vw * (15 / 1920));
        text-align: center;

        word-break: break-all;

        padding: 0 calc(100vw * (5 / 1920));
    }
    & > div:nth-child(1) {
        width: calc(100vw * (124 / 1920));
    }
    & > div:nth-child(2) {
        width: calc(100vw * (465 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (156 / 1920));
    }
    & > div:nth-child(4) {
        width: calc(100vw * (95 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & > div {
            font-size: calc(100vw * (15 / 1300));

            padding: 0 calc(100vw * (5 / 1300));
        }
        & > div:nth-child(1) {
            width: calc(100vw * (124 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (465 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (156 / 1300));
        }
        & > div:nth-child(4) {
            width: calc(100vw * (95 / 1300));
        }
    }
`;
const Date = styled.div``;
const OrderNum = styled.div``;
const OrderPrice = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const Paging = styled.div`
    margin-top: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (60 / 1300));
    }
`;
